// extracted by mini-css-extract-plugin
module.exports = {"button":"inputCalculator_button__uHoZf","input":"inputCalculator_input__3qc01","wrapper":"inputCalculator_wrapper__1PeCG"};